export default __webpack_public_path__ + "static/aderenciaSistemas2-a0c6d96e1f0d232fb24765d9bdb55629.jpeg";